// IMPORTANT NOTE: Please don't import other selectors from this file.
// Use secondOrder and *ThirdOrder for your selector if it has other
// dependencies.
import { createSelector } from 'reselect'

import { fullSystemStateSelector } from './fullFileFirstOrder'

/**
 * @typedef {import('../index').PlottrState} PlottrState
 * @typedef {import('../types/system').Offline} Offline
 * @typedef {import('../types/system').OfflineFilesEntry} OfflineFilesEntry
 * @typedef {import('../types/system').CreatedOfflineFileEntry} CreatedOfflineFilesEntry
 */

/**
 * @type {function(PlottrState): Offline}
 */
export const offlineSelector = createSelector(
  fullSystemStateSelector,
  ({ offline }) =>
    offline ?? {
      offlineFiles: [],
      createdOfflineFiles: [],
    }
)
/**
 * @type {function(PlottrState): Array<OfflineFilesEntry>}
 */
export const offlineFilesSelector = createSelector(offlineSelector, ({ offlineFiles }) => {
  return offlineFiles
})
/**
 * @type {function(PlottrState): Array<CreatedOfflineFilesEntry>}
 */
export const createdOfflineFilesSelector = createSelector(
  offlineSelector,
  ({ createdOfflineFiles }) => {
    return createdOfflineFiles
  }
)
